import Labeled from 'admin/components/atoms/Labeled';
import TextBox from 'admin/components/atoms/TextBox';
import React, { forwardRef } from 'react';
import styled, { StyledComponentPropsWithRef } from 'styled-components';

type Props = StyledComponentPropsWithRef<typeof Labeled> &
  StyledComponentPropsWithRef<typeof TextBox>;

const LabeledTextBox = forwardRef<HTMLInputElement, Props>(
  ({ labelText, className, innerRef, required, ...rest }, ref) => (
    <Labeled className={className} labelText={labelText} required={required} {...rest}>
      <TextBox innerRef={innerRef} required={required} ref={innerRef || ref} {...rest} />
    </Labeled>
  )
);

export default styled(LabeledTextBox)``;
